import PageShell from "@/components/feature/PageShell";
import useSeo from "@/hooks/useSeo";
import { FAQ_ITEMS } from "@/mocks/faq";
import { SITE_NAME } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Featured from "./components/Featured";
import Process from "./components/Process";
import Editorial from "./components/Editorial";
import Faq from "./components/Faq";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: "https://gjkmv.cn/",
    logo: "https://gjkmv.cn/vite.svg",
    description: "明星黑料分类档案盘点平台，覆盖人品争议、感情纠纷、耍大牌、违约失信、言论翻车、行为失当六大分类。",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: "https://gjkmv.cn/",
    inLanguage: "zh-CN",
    publisher: { "@type": "Organization", name: SITE_NAME },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "明星黑料档案｜人品争议感情纠纷耍大牌违约翻车分类盘点",
    description:
      "明星黑料分类档案库，把人品争议、感情纠纷、耍大牌、违约失信、言论翻车、行为失当等黑料分门别类整理，梳理艺人塌房全过程，一次吃透所有瓜。",
    keywords: "明星黑料,明星黑料人品争议,明星黑料感情纠纷,明星黑料耍大牌,明星黑料言论翻车,明星黑料行为失当",
    path: "/",
    jsonLd,
  });

  return (
    <PageShell>
      <Hero />
      <Categories />
      <Featured />
      <Process />
      <Editorial />
      <Faq />
    </PageShell>
  );
}